import api from "./Api";

class CompraDFeManifestoService {
  ManifestarDocumento(payload) {
    return api
      .get("/v1/compraDFeManifesto/ManifestarDocumento" + payload)
      .then((response) => {
        return response.data;
      });
  }

  ObterNotas(payload) {
    return api
      .get("/v1/compraDFeManifesto/ObterNotas" + payload)
      .then((response) => {
        return response.data;
      });
  }

  ObterCTe(payload) {
    return api
      .get("/v1/compraDFeManifesto/ObterCTe" + payload)
      .then((response) => {
        return response.data;
      });
  }

  BaixarXML(payload) {
    return api
      .get("/v1/compraDFeManifesto/DownloadXML" + payload)
      .then((response) => {
        return response.data;
      });
  }

  ImprimirNFe(payload) {
    return api
      .get("/v1/compraDFeManifesto/ImprimirNFe/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetCompraDFeManifesto(payload) {
    return api.get("/v1/compraDFeManifesto/" + payload).then((response) => {
      return response.data;
    });
  }

  PostCompraDFeManifesto(payload) {
    return api.post("/v1/compraDFeManifesto/", payload).then((response) => {
      return response.data;
    });
  }

  PutCompraDFeManifesto(payload) {
    return api.put("/v1/compraDFeManifesto/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteCompraDFeManifesto(payload) {
    return api.delete("/v1/compraDFeManifesto/" + payload).then((response) => {
      return response.data;
    });
  }

  GetCompraDFeManifestoOData(payload) {
    return api.get("/OData/compraDFeManifesto" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new CompraDFeManifestoService();
